/* brand-cart.js — sepet bileşeni yardımcısı (U07, 09.10.2026). Modül; brand-cart bölümü ve brand-cart-drawer snippet'i yükler.
 * Tek iş: gsw-cart-guard yetim servis satırını süpürünce (`gsw:cart-swept`) açık sepet bileşenlerini Horizon'un kendi
 * bölüm render'ıyla tazeler (çekmece / başka sayfa). /cart sayfasında bekçi zaten sayfayı yeniden yükler; burada atlanır.
 * Horizon olay adı taklit edilmez; yalnız Horizon modülü (section-renderer) çağrılır.
 */
import { sectionRenderer } from '@theme/section-renderer';

const cartPath = () => {
  let url = (window.BRAND && window.BRAND.routes && window.BRAND.routes.cart) || '/cart';
  try {
    // Horizon snippets/scripts.liquid: `const Theme = { routes: { cart_url } }` (global lexical; window'da değil)
    // eslint-disable-next-line no-undef
    if (url === '/cart' && typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) url = Theme.routes.cart_url;
  } catch (e) {
    /* yok say */
  }
  return url.replace(/\/+$/, '');
};

document.addEventListener('gsw:cart-swept', () => {
  if (location.pathname.replace(/\/+$/, '') === cartPath()) return;
  const ids = new Set();
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.add(el.dataset.sectionId);
  });
  ids.forEach((id) => {
    sectionRenderer.renderSection(id, { cache: false }).catch(() => {});
  });
});
